import { formatCurrency } from "@brazilian-utils/brazilian-utils";
import { Box, Flex, Text } from "@chakra-ui/react";
import { Col, Row } from "antd";
import colors from "core/resources/theme/colors";
import ButtonActionConciliacao from "../ButtonActionConciliacao";
import TagStatusConciliacao from "../TagStatusConciliacao";
import TagValorConciliacao from "../TagValorConciliacao";
import { ButtonActionConciliacaoActionItem } from "../ButtonActionConciliacao";
import { OperacaoEnum } from "core/resources/enums/conta";
import { DadosExtratoBancarioListResponse } from "features/conciliacao-bancaria/typings";
import ModalConciliar from "./../ModalConciliar/index";
import { useState } from "react";

export interface RowData extends DadosExtratoBancarioListResponse {
  primeiroItem: boolean;
  ultimoItem: boolean;
  bg?: string;
  id: string;
}
interface RowTableProps {
  rowData: RowData;
  actions?: ButtonActionConciliacaoActionItem<RowData>[];
  refetch?: () => any;
  mes: string;
  contasBancariasIds?: string[];
}

export default function RowTable({
  rowData,
  actions,
  mes,
  refetch,
  contasBancariasIds,
}: RowTableProps) {
  const {
    descricaoExtratoBancario,
    contas,
    data,
    conciliado,
    subDescricaoExtrato,
    tenantContaId,
    valor,
    primeiroItem,
    bg,
    id,
  } = rowData;

  const [isOpenModal, setIsOpenModal] = useState(false);

  const operacao =
    valor && valor < 0 ? OperacaoEnum.Despesa : OperacaoEnum.Receita;

  return (
    <>
      <Box
        as={Row}
        gutter={32}
        py={2}
        bg={bg}
        roundedTop={primeiroItem ? 16 : 0}
        justifyContent="center"
        onClick={() => (conciliado ? setIsOpenModal(true) : "")}
        cursor={conciliado ? "pointer" : ""}
      >
        <Col xs={6}>
          <Flex flexDirection="column" justifyContent="center" h="100%">
            <Text>{descricaoExtratoBancario}</Text>
            <Text color={colors.black} fontSize={12}>
              {subDescricaoExtrato}
            </Text>
          </Flex>
        </Col>
        <Col xs={6}>
          <Flex
            justifyContent="end"
            h="100%"
            align="center"
            color={operacao === OperacaoEnum.Despesa ? colors.red : undefined}
          >
            {valor ? `R$ ${formatCurrency(valor)}` : <TagValorConciliacao />}
          </Flex>
        </Col>
        <Col xs={6}>
          <Flex h="100%" align="center">
            {contas.length === 1
              ? contas[0].descricao
              : contas.length > 1
              ? `${contas.length} cobranças`
              : null}
          </Flex>
        </Col>
        <Col xs={4}>
          <Flex justifyContent="center" h="100%" alignItems="center">
            <TagStatusConciliacao
              extratoId={id}
              extratoData={data}
              valor={valor!}
              conciliado={conciliado}
              operacao={operacao}
              tenantContaIdExtrato={tenantContaId}
              mes={mes}
              refetch={refetch}
              contasBancariasIds={contasBancariasIds}
            />
          </Flex>
        </Col>
        <Flex as={Col} xs={2} alignItems="center" justifyContent="end">
          <Flex justifyContent="end" alignItems="center" alignSelf="center">
            <ButtonActionConciliacao original={rowData} actions={actions} />
          </Flex>
        </Flex>
      </Box>

      {isOpenModal ? (
        <ModalConciliar
          conciliado={true}
          valor={valor}
          visible={isOpenModal}
          onClose={() => setIsOpenModal(false)}
          operacao={operacao}
          extratoId={id}
          extratoData={data}
          mes={mes}
          refetch={refetch}
          tenantContaIdExtrato={tenantContaId}
          contasBancariasIds={contasBancariasIds}
        />
      ) : null}
    </>
  );
}
